import { styled } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'none',
  '@tablet': {
    display: 'block',
    paddingTop: '8px'
  }
})

const Header = styled('div', {
  paddingBottom: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: '$blackA100',
  marginBottom: '12px'
})

const Title = styled('div', {
  fontSize: '$18',
  lineHeight: '16px',
  fontWeight: 500,
  letterSpacing: '-0.025em'
})

const Stats = styled('div', {
  fontSize: '$14',
  lineHeight: '16px',
  fontWeight: 500
})

const Content = styled('div')

export const Recent = { Root, Header, Title, Stats, Content }
